import { t } from "i18next";
import * as React from "react";
function PosRequestGuide() {
    return (
        <div style={{ borderBottom: "2px solid #c4960c", marginBottom: "1%" }}>
            <div class="border-box-sc row" id="guideDiv">
                <div class="col-md-12 form-group  description-small-customer">
                    <label class="col-md-12" >{t("guideposiform")}</label>
                    <div class="col-md-6 form-group">
                        <label class="col-md-12">
                            <i class="fa fa-circle" style={{ color: "#c59812", fontSize: "xx-small" }}></i>
                            {t("viewhelpposclip")}
                        </label>
                        <div class="col-md-12 form-group">
                            <label class="col-md-12" style={{ marginLeft: "15px" }}>{t("viewchangecontactpos")}
                                <a rel="noopener" style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }} href="https://www.youtube.com/watch?v=UMUQRJMKoZA&amp;list=PLj-B3Hp9WnW7xMXxIFsScdiptL7-YFPeL&amp;index=3" target="_blank" data-anchor="?v=UMUQRJMKoZA&amp;list=PLj-B3Hp9WnW7xMXxIFsScdiptL7-YFPeL&amp;index=3">{t("herepos")}</a>
                            </label>
                            <label class="col-md-12" style={{ marginLeft: "15px" }}>{t("viewchangepersonalpos")}
                                <a rel="noopener" style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }} href="https://www.youtube.com/watch?v=1L7LsDPF6mk&amp;list=PLj-B3Hp9WnW7xMXxIFsScdiptL7-YFPeL&amp;index=2" target="_blank" data-anchor="?v=1L7LsDPF6mk&amp;list=PLj-B3Hp9WnW7xMXxIFsScdiptL7-YFPeL&amp;index=2">{t("herepos")}</a>
                            </label>
                            <label class="col-md-12" style={{ marginLeft: "15px" }}>{t("viewchangefrequencypos")}
                                <a rel="noopener" style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }} href="https://www.youtube.com/watch?v=2zE8cpEEjRA&amp;list=PLj-B3Hp9WnW7xMXxIFsScdiptL7-YFPeL&amp;index=1" target="_blank" data-anchor="?v=2zE8cpEEjRA&amp;list=PLj-B3Hp9WnW7xMXxIFsScdiptL7-YFPeL&amp;index=1">{t("herepos")}</a>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="col-md-12">
                            <i class="fa fa-circle" style={{ color: "#c59812", fontSize: "xx-small" }}></i>
                            {t("viewhelpposdoc")}
                        </label>
                        <div class="col-md-12 form-group">
                            <label class="col-md-12" style={{ marginLeft: "15px" }}>{t("viewchangecontactpos")}
                                <a style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }} href="https://www.phuhunglife.com/media/utihupgt/huong-dan-su-dung-iform-yeu-cau-thay-doi-thong-tin.pdf" target="_blank">{t("herepos")}</a>
                            </label>
                            <label class="col-md-12" style={{ marginLeft: "15px" }}>{t("viewchangepersonalpos")}
                                <a style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }} href="https://www.phuhunglife.com/media/fh5crq1l/huong-dan-su-dung-iform-yeu-cau-thay-doi-thong-tin-ca-nhan-kh.pdf" target="_blank">{t("herepos")}</a>
                            </label>
                            <label class="col-md-12" style={{ marginLeft: "15px" }}>{t("viewchangefrequencypos")}
                                <a style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }} href="https://www.phuhunglife.com/media/2cof1qfm/huong-dan-su-dung-iform-yeu-cau-thay-doi-dinh-ky-dong-phi.pdf" target="_blank">{t("herepos")}</a>
                            </label>
                        </div>
                    </div>

                    <label class="col-md-12" >{t("identityrequiredpos")}</label>
                </div>
            </div>
        </div>
    )
}

export default PosRequestGuide;

